import { DeveloperConsole } from '../../../library';
var dconsole = new DeveloperConsole('Smart Select Step', ['#E5145F', '#FFFFFF']);
export function SmartSelectSection(props) {
    dconsole.log(props);
    return null;
}
export default SmartSelectSection;
